export const ArtInfos = [
    {
      "Title": "Textual (Textuel)",
      "Artist": "Piet Mondrian",
      "Date": 1928,
      "URL": "http://www.moma.org/collection/works/59980",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIzMzMwMCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=8e63da01423dc444",
      "Popularity": 5023
    },
    {
      "Title": "Dr. Waldmann from Expressionist Woodcuts",
      "Artist": "Roy Lichtenstein",
      "Date": 1980,
      "URL": "http://www.moma.org/collection/works/59857",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjY5NjI2Il0sWyJwIiwiY29udmVydCIsIi1yZXNpemUgMzAweDMwMFx1MDAzZSJdXQ.jpg?sha=d171a2a89bfe6e76",
      "Popularity": 4327
    },
    {
      "Title": "Two Paintings: Dagwood from the \"Painting\" Series",
      "Artist": "Roy Lichtenstein",
      "Date": 1984,
      "URL": "http://www.moma.org/collection/works/59900",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjQ3NzM0NiJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=1ba469502ee5521e",
      "Popularity": 4243
    },
    {
      "Title": "The Couple from Expressionist Woodcuts",
      "Artist": "Roy Lichtenstein",
      "Date": 1980,
      "URL": "http://www.moma.org/collection/works/59859",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIwODAwMyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=fc4c786ea56e0c4c",
      "Popularity": 4003
    },
    {
      "Title": "Untitled from Untitled",
      "Artist": "Barbara Kruger",
      "Date": 1985,
      "URL": "http://www.moma.org/collection/works/59854",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIwNTA4NCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=2754dabde9f094b2",
      "Popularity": 3874
    },
    {
      "Title": "Head from Expressionist Woodcuts",
      "Artist": "Roy Lichtenstein",
      "Date": 1980,
      "URL": "http://www.moma.org/collection/works/59861",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIwODAwNCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=6c7d77f376d1c524",
      "Popularity": 3822
    },
    {
      "Title": "Coverings (Überdeckungen)",
      "Artist": "Arnulf Rainer",
      "Date": 1961,
      "URL": "http://www.moma.org/collection/works/59863",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjE4OTU3OCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=cd45d0d41ecb25d4",
      "Popularity": 2003
    },
    {
      "Title": "Ex Libris Edmond Bomsel",
      "Artist": "Alberto Giacometti",
      "Date": 1961,
      "URL": "http://www.moma.org/collection/works/59865",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjE2MzM1MyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=b70416b0c22cc666",
      "Popularity": 1847
    },
    {
      "Title": "The Two Sided Flower",
      "Artist": "Donald Baechler",
      "Date": 1996,
      "URL": "http://www.moma.org/collection/works/59868",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjE3Njc0OSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=229ae594d13581bf",
      "Popularity": 1482
    },
    {
      "Title": "Sarika",
      "Artist": "Max Beckmann",
      "Date": 1922,
      "URL": "http://www.moma.org/collection/works/59869",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjExNTU0NSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=dfe70d064b462775",
      "Popularity": 1222
    },
    {
      "Title": "Mother (Mutter) from the portfolio Ten Woodcuts by Schmidt-Rottluff (Zehn Holzschnitte von Schmidt-Rottluff)",
      "Artist": "Karl Schmidt-Rottluff",
      "Date": 1916,
      "URL": "http://www.moma.org/collection/works/59886",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjEyMDEyMiJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=931997b72091de4f",
      "Popularity": 1049
    },
    {
      "Title": "In the Rowboat (Im Ruderboot)",
      "Artist": "Conrad Felixmüller",
      "Date": 1920,
      "URL": "http://www.moma.org/collection/works/59888",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjE3MDY2NSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=970ba94049d423b5",
      "Popularity": 932
    },
    {
      "Title": "Untitled from Untitled",
      "Artist": "Craig Kauffman",
      "Date": 1971,
      "URL": "http://www.moma.org/collection/works/59890",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjM5NDkyMyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=104a111f88bcac51",
      "Popularity": 922
    },
    {
      "Title": "Nothing Doing",
      "Artist": "Pieter Holstein",
      "Date": 1969,
      "URL": "http://www.moma.org/collection/works/59891",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIxNjEzMyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=3d98e815a5c3a6a5",
      "Popularity": 623
    },
    {
      "Title": "Main Street",
      "Artist": "Saul Steinberg",
      "Date": 1973,
      "URL": "http://www.moma.org/collection/works/59892",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjI0ODg0MyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=8f7034cf7fc9ac15",
      "Popularity": 523
    },
    {
      "Title": "Untitled",
      "Artist": "Fred Sandback",
      "Date": 1975,
      "URL": "http://www.moma.org/collection/works/59894",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIyMTIzNyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=424679c027057deb",
      "Popularity": 511
    },
    {
      "Title": "Psychologische Improvisation IV: Vigilanz (Psychological Improvisation IV: Vigilance)",
      "Artist": "Carlfriedrich Claus",
      "Date": 1972,
      "URL": "http://www.moma.org/collection/works/59895",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjEwMDc0MSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=3b39a876d9a8c6e6",
      "Popularity": 424
    },
    {
      "Title": "Light Etching",
      "Artist": "Nachume Miller",
      "Date": 1979,
      "URL": "http://www.moma.org/collection/works/59896",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIzMzI4MyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=3ab64c1a4806cfea",
      "Popularity": 412
    },
    {
      "Title": "The Razorback Bunch (Etching IV)",
      "Artist": "Robert Rauschenberg",
      "Date": 1981,
      "URL": "http://www.moma.org/collection/works/59897",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjM5MzkzMiJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=6325fef4cb3982c0",
      "Popularity": 399
    },
    {
      "Title": "Moonscape",
      "Artist": "Roy Lichtenstein",
      "Date": 1985,
      "URL": "http://www.moma.org/collection/works/59899",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjQ3NzM0NSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=2613652bfbebfd6e",
      "Popularity": 387
    },
    {
      "Title": "Window (Fenster)",
      "Artist": "Arnulf Rainer",
      "Date": 1961,
      "URL": "http://www.moma.org/collection/works/59901",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIxOTg2MCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=4be7f3b1dbaa00f7",
      "Popularity": 325
    },
    {
      "Title": "The Horizontal Bars (Reckakt)",
      "Artist": "Erich Heckel",
      "Date": 1919,
      "URL": "http://www.moma.org/collection/works/59903",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjExMzQzNiJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=e0f2e1c38275a77f",
      "Popularity": 309
    },
    {
      "Title": "Mur-Murmure",
      "Artist": "Gregory Masurovsky",
      "Date": 1975,
      "URL": "http://www.moma.org/collection/works/59904",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjE4MDA1NiJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=09822868373892b6",
      "Popularity": 290
    },
    {
      "Title": "Art",
      "Artist": "Robert Indiana",
      "Date": 1992,
      "URL": "http://www.moma.org/collection/works/59905",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjE2NjA1NCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=01bb40786014da40",
      "Popularity": 288
    },
    {
      "Title": "The Grenade (Die Granate)",
      "Artist": "Max Beckmann",
      "Date": 1915,
      "URL": "http://www.moma.org/collection/works/59906",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjY3NTE1Il0sWyJwIiwiY29udmVydCIsIi1yZXNpemUgMzAweDMwMFx1MDAzZSJdXQ.jpg?sha=04f0cc9958a66026",
      "Popularity": 287
    },
    {
      "Title": "Behind the Scenes (Hinter den Kulissen) for the portfolio Annual Fair (Jahrmarkt)",
      "Artist": "Max Beckmann",
      "Date": 1921,
      "URL": "http://www.moma.org/collection/works/59907",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjExNTU0NiJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=fe7b93094f1de86a",
      "Popularity": 235
    },
    {
      "Title": "The Three Magi (Die heiligen drei Könige) from the portfolio Ten Woodcuts by Schmidt-Rottluff (Zehn Holzschnitte von Schmidt-Rottluff)",
      "Artist": "Karl Schmidt-Rottluff",
      "Date": 1917,
      "URL": "http://www.moma.org/collection/works/59908",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjExMzU2MCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=498a2b06ee03a9aa",
      "Popularity": 224
    },
    {
      "Title": "Valencia",
      "Artist": "Henri Laurens",
      "Date": 1927,
      "URL": "http://www.moma.org/collection/works/59909",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjE2NjA2MyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=981a04e4c242a948",
      "Popularity": 124
    },
    {
      "Title": "Ideogram",
      "Artist": "Willi Baumeister",
      "Date": 1937,
      "URL": "http://www.moma.org/collection/works/59910",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIxNDA2NiJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=d8a172ecefc0150c",
      "Popularity": 96
    },
    {
      "Title": "Untitled",
      "Artist": "Fayga Ostrower",
      "Date": 1958,
      "URL": "http://www.moma.org/collection/works/59911",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIxOTQ5NSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=5bceefc06b66cf8f",
      "Popularity": 88
    },
    {
      "Title": "Untitled",
      "Artist": "Adolf Richard Fleischmann",
      "Date": 1959,
      "URL": "http://www.moma.org/collection/works/59912",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIyMDM2MiJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=8c973555c5b7c505",
      "Popularity": 87
    },
    {
      "Title": "Untitled from Untitled",
      "Artist": "Craig Kauffman",
      "Date": 1971,
      "URL": "http://www.moma.org/collection/works/59913",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjM5NTEyNyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=6997091693638bc7",
      "Popularity": 73
    },
    {
      "Title": "93-B",
      "Artist": "Pieter Holstein",
      "Date": 1970,
      "URL": "http://www.moma.org/collection/works/59914",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIxNjEzNiJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=017c5aa007ff099b",
      "Popularity": 53
    },
    {
      "Title": "Probability",
      "Artist": "Steven Cortright",
      "Date": 1978,
      "URL": "http://www.moma.org/collection/works/59917",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIxODMwMCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=f1a083f650f94022",
      "Popularity": 49
    },
    {
      "Title": "With Music (Con Musica)",
      "Artist": "Mimmo Paladino",
      "Date": 1980,
      "URL": "http://www.moma.org/collection/works/59918",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjI3NjI4NyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=81f0d627456f1e8a",
      "Popularity": 4
    },
    {
      "Title": "Untitled",
      "Artist": "Carry (Carl Maria) Hauser",
      "Date": 1918,
      "URL": "http://www.moma.org/collection/works/59928",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjI3NTE5MCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=44f44907c652d007",
      "Popularity": 4
    },
    {
      "Title": "Crooked Departure (Krummer Abgang)",
      "Artist": "Arnulf Rainer",
      "Date": 1976,
      "URL": "http://www.moma.org/collection/works/59931",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjEwMDgxNiJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=4dc6160ef716c5ae",
      "Popularity": 2
    },
    {
      "Title": "Exit",
      "Artist": "Bill Jensen",
      "Date": 1989,
      "URL": "http://www.moma.org/collection/works/59933",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjE2NjA2NCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=2e1b69bb508c2f95",
      "Popularity": 2
    },
    {
      "Title": "What is Written is Written (El Maktoub Maktoub)",
      "Artist": "Not Vital",
      "Date": 1990,
      "URL": "http://www.moma.org/collection/works/59934",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIzNzc2NSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=cf557737591a2ba1",
      "Popularity": 2
    },
    {
      "Title": "Summer (Blue)",
      "Artist": "Jasper Johns",
      "Date": 1991,
      "URL": "http://www.moma.org/collection/works/59935",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjE2NjA2NSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=7b894956311dd624",
      "Popularity": 2
    },
    {
      "Title": "The Fur Cap (Die Pelzmütze)",
      "Artist": "Max Beckmann",
      "Date": 1923,
      "URL": "http://www.moma.org/collection/works/59937",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjExMjg2MCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=802c7649b0470340",
      "Popularity": 2
    },
    {
      "Title": "Strategy",
      "Artist": "Jan Forsberg",
      "Date": 1965,
      "URL": "http://www.moma.org/collection/works/59940",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIyMDM3NCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=df5de747e4653260",
      "Popularity": 1
    },
    {
      "Title": "Untitled from Untitled",
      "Artist": "Craig Kauffman",
      "Date": 1971,
      "URL": "http://www.moma.org/collection/works/59941",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjM5NTEyOSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=20b11cf2ab32cd6f",
      "Popularity": 1
    },
    {
      "Title": "Untitled from Five Plates",
      "Artist": "Brice Marden",
      "Date": 1973,
      "URL": "http://www.moma.org/collection/works/59943",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjM0MDI1OCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=e129efe510d12484",
      "Popularity": 1
    },
    {
      "Title": "Untitled from Five Plates",
      "Artist": "Brice Marden",
      "Date": 1973,
      "URL": "http://www.moma.org/collection/works/59945",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjM0MDI1OSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=a9d665deb5a2626b",
      "Popularity": 1
    },
    {
      "Title": "Untitled from Five Plates",
      "Artist": "Brice Marden",
      "Date": 1973,
      "URL": "http://www.moma.org/collection/works/59946",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjM0MDI2MCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=bb368527ad59a0e2",
      "Popularity": 1
    },
    {
      "Title": "Untitled from Five Plates",
      "Artist": "Brice Marden",
      "Date": 1973,
      "URL": "http://www.moma.org/collection/works/59947",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjM0MDI2MSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=57e731b1196bae0d",
      "Popularity": 1
    },
    {
      "Title": "Untitled from Five Plates",
      "Artist": "Brice Marden",
      "Date": 1973,
      "URL": "http://www.moma.org/collection/works/59948",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjM0MDI2MiJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=30f041dce28efd64",
      "Popularity": 1
    },
    {
      "Title": "Wall Chart I",
      "Artist": "Jim Dine",
      "Date": 1973,
      "URL": "http://www.moma.org/collection/works/59950",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjQ3NzM2NSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=581be1f54abdb965",
      "Popularity": 1
    },
    {
      "Title": "The Razorback Bunch (Etching II)",
      "Artist": "Robert Rauschenberg",
      "Date": 1980,
      "URL": "http://www.moma.org/collection/works/59951",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjM5Mzk0MiJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=aaee0d53a0fb5be9",
      "Popularity": 1
    },
    {
      "Title": "Untitled from Bedroom Portfolio",
      "Artist": "Tom Wesselmann",
      "Date": 1978,
      "URL": "http://www.moma.org/collection/works/59952",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIzNzc2MCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=bd943fbc6af8f31d",
      "Popularity": 1
    },
    {
      "Title": "To the Palette for A La Pintura",
      "Artist": "Robert Motherwell",
      "Date": 1969,
      "URL": "http://www.moma.org/collection/works/59959",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIzMzkyMCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=47f44d071e79e125",
      "Popularity": 1
    },
    {
      "Title": "Hidden Departure (Versteckter Abgang) from the series Fearful Hiding (Schreckversteck)",
      "Artist": "Arnulf Rainer",
      "Date": 1978,
      "URL": "http://www.moma.org/collection/works/59960",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjEwMDgxNyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=9159e5f192707c5a",
      "Popularity": 1
    },
    {
      "Title": "Untitled",
      "Artist": "Mario Merz",
      "Date": 1988,
      "URL": "http://www.moma.org/collection/works/59961",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjI3NDk2MyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=3fe7aee42dca8923",
      "Popularity": 1
    },
    {
      "Title": "Arsenal (Zeughaus)",
      "Artist": "Sigmar Polke",
      "Date": 1976,
      "URL": "http://www.moma.org/collection/works/59963",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjI1NjYxMCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=251c795f21158946",
      "Popularity": 1
    },
    {
      "Title": "Untitled",
      "Artist": "Jasper Johns",
      "Date": 1992,
      "URL": "http://www.moma.org/collection/works/59964",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjI5MTc3NCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=305c1b790eb178f7",
      "Popularity": 1
    },
    {
      "Title": "Shooting Gallery (Schiessbude) for the portfolio Annual Fair (Jahrmarkt)",
      "Artist": "Max Beckmann",
      "Date": 1921,
      "URL": "http://www.moma.org/collection/works/59966",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjExNTU0NyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=b97473352fc9f99f",
      "Popularity": 1
    },
    {
      "Title": "Album of Prints (Album de grabados)",
      "Artist": "Jesús Morales Aguilar",
      "Date": 1933,
      "URL": "http://www.moma.org/collection/works/59967",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIyMzA2NSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=0458f6ba0e7e6c8e",
      "Popularity": 0
    },
    {
      "Title": "Group Portrait, Eden Bar (Gruppenbildnis Edenbar)",
      "Artist": "Max Beckmann",
      "Date": 1923,
      "URL": "http://www.moma.org/collection/works/59968",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjExODg2NyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=fad09d464e456599",
      "Popularity": 0
    },
    {
      "Title": "Untitled from Untitled",
      "Artist": "Craig Kauffman",
      "Date": 1971,
      "URL": "http://www.moma.org/collection/works/59971",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjM5NTEzMSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=71d61254cc16dbfd",
      "Popularity": 0
    },
    {
      "Title": "The Magdalenians (Les magdaléniens)",
      "Artist": "Joan Miró",
      "Date": 1958,
      "URL": "http://www.moma.org/collection/works/59973",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjE2NzQ0NCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=36bcb3c907638890",
      "Popularity": 0
    },
    {
      "Title": "Railroad Crossing (Eisenbahnüberführung)",
      "Artist": "Georg Ehrlich",
      "Date": 1921,
      "URL": "http://www.moma.org/collection/works/59974",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjE4MTUyMyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=8ef22b54f4eb53eb",
      "Popularity": 0
    },
    {
      "Title": "White (Pendulum)",
      "Artist": "Robert Rauschenberg",
      "Date": 1980,
      "URL": "http://www.moma.org/collection/works/59975",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjEyMzI4NyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=f1ff09f846899d4d",
      "Popularity": 0
    },
    {
      "Title": "Studio",
      "Artist": "Bill Jensen",
      "Date": 1984,
      "URL": "http://www.moma.org/collection/works/59976",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjE2NjExOCJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=8dd4ea1d106f1c27",
      "Popularity": 0
    },
    {
      "Title": "Head",
      "Artist": "Markus Raetz",
      "Date": 1982,
      "URL": "http://www.moma.org/collection/works/59977",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjE4MDkzNyJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=059d3a365a5914f1",
      "Popularity": 0
    },
    {
      "Title": "my eye is a mouth",
      "Artist": "Dieter Roth",
      "Date": 1966,
      "URL": "http://www.moma.org/collection/works/59978",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjIzODg4NSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=089366eb591a9c4e",
      "Popularity": 0
    },
    {
      "Title": "Winter",
      "Artist": "Jasper Johns",
      "Date": 1989,
      "URL": "http://www.moma.org/collection/works/59981",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjE2NjExOSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=98636ff1a03190ac",
      "Popularity": 0
    },
    {
      "Title": "Dark Loop",
      "Artist": "Martin Puryear",
      "Date": 1982,
      "URL": "http://www.moma.org/collection/works/59982",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjQwMDY1MSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=a312da812d7e0a20",
      "Popularity": 0
    },
    {
      "Title": "Rapunzel's Syndrome from an untitled series",
      "Artist": "Ronald Jones",
      "Date": 1992,
      "URL": "http://www.moma.org/collection/works/59983",
      "ThumbnailURL": "http://www.moma.org/media/W1siZiIsIjE5MjE2OSJdLFsicCIsImNvbnZlcnQiLCItcmVzaXplIDMwMHgzMDBcdTAwM2UiXV0.jpg?sha=57f77330eff8ba37",
      "Popularity": 0
    }      
]